<template>
    <!-- Preview mode -->
    <div class="h-full relative">
        <img class="preview-background" src="/build/public/images/backgrounds/room.jpg" />
        <div id="ayv-thumbnail"></div>
    </div>
</template>

<script>
import Pipeline from "../../../Pipeline/Pipeline";

export default {
    mounted() {
        Pipeline.generateFinalImagePreview();
    }
};
</script>
